import React from 'react';
import { LuPencil, LuCopy, LuFileText, LuPause, LuPlay, LuArchive, LuTrash2, LuWrench, LuShoppingCart, LuRotateCcw, LuEye, LuCalendarX, LuClipboardList, LuBuilding2 } from 'react-icons/lu';
import ActionSheet from '../ui/ActionSheet';

// Botón de una fila de menú (mismo estilo en los dos sheets)
function Opcion({ Icon, label, sub, onClick, peligro = false }) {
    return (
        <button type="button" onClick={onClick}
            className={`w-full flex items-center gap-3 px-4 py-3.5 rounded-xl text-left active:bg-chip transition-colors ${peligro ? 'text-[#D13A28] dark:text-[#F87171]' : 'text-ink'}`}>
            <Icon size={18} className="shrink-0" />
            <span className="min-w-0">
                <span className="block text-body font-bold">{label}</span>
                {sub && <span className="block text-caption text-muted">{sub}</span>}
            </span>
        </button>
    );
}

// "+ Nuevo": qué querés cargar. 1-nov-2026: un camino por cosa. Las empresas con cobro mensual van solo por
// "Pedido de empresa" (antes también entraban por Visita y por Trabajo, con pasos distintos).
export function NuevoSheet({ open, onClose, onElegir, conEmpresas = false }) {
    const elegir = (q) => { onClose(); onElegir(q); };
    return (
        <ActionSheet open={open} onClose={onClose}>
            <p className="px-4 pt-1 pb-2 text-label font-black uppercase tracking-widest text-muted">Nuevo</p>
            <Opcion Icon={LuWrench} label="Trabajo / presupuesto" sub="Con precio: service, reparación o instalación" onClick={() => elegir('nuevo')} />
            {conEmpresas && <Opcion Icon={LuBuilding2} label="Pedido de empresa" sub="Clientes con cobro mensual · va al cierre del mes" onClick={() => elegir('pedido')} />}
            {/* 1-nov-2026: sin "Visita sin presupuesto". El "no sé qué tiene" también va por Trabajo: se presupuesta
                y, si no se hace, se cobra la mitad de la mano de obra (lo dicen las condiciones del PDF). */}
            <Opcion Icon={LuShoppingCart} label="Venta" sub="Productos sin visita técnica" onClick={() => elegir('venta')} />
        </ActionSheet>
    );
}

// "Pedido de empresa" con más de una empresa con cobro mensual: ¿de cuál?
export function ElegirEmpresaSheet({ empresas, onClose, onElegir }) {
    return (
        <ActionSheet open={!!empresas} onClose={onClose}>
            <p className="px-4 pt-1 pb-2 text-label font-black uppercase tracking-widest text-muted">¿De qué empresa?</p>
            {(empresas || []).map(e => (
                <Opcion key={e.id} Icon={LuBuilding2} label={e.nombre} onClick={() => { onClose(); onElegir(e); }} />
            ))}
        </ActionSheet>
    );
}

// ⋯ de cada trabajo. Solo muestra lo que tiene sentido según la etapa.
export function TrabajoMenu({ fila, onClose, on }) {
    const s = fila?.servicio;
    const abierto = !!fila;
    if (!abierto) return null;
    const run = (fn) => () => { onClose(); fn(); };
    const esArchivado = s?.estado === 'ARCHIVADO';
    const editable = s && ['PRESUPUESTO', 'APROBADO', 'EN_PROGRESO'].includes(s.estado);
    return (
        <ActionSheet open={abierto} onClose={onClose}>
            <p className="px-4 pt-1 pb-2 text-label font-black uppercase tracking-widest text-muted truncate">{fila.cliente}</p>
            {/* Renglón de cierre mensual (7-oct-2026): los trabajos del mes. Tocar uno abre su
                propio menú (ver, PDF, archivar, eliminar) — 11-oct-2026 */}
            {fila.servicios?.length > 0 && (
                <>
                    {fila.servicios.map(sv => {
                        const series = (sv.items || []).map(i => i.equipoSerial).filter(x => x && x !== 'MOSTRADOR');
                        const f = String(sv.fecha || '').slice(0, 10).split('-').reverse().slice(0, 2).join('/');
                        return <Opcion key={sv.id} Icon={LuEye} label={`${f} · ${series.length ? series.slice(0, 3).join(', ') + (series.length > 3 ? ` +${series.length - 3}` : '') : 'Trabajo #' + sv.id}`}
                            sub={[sv.sedeNombre, sv.usuarioNombre].filter(Boolean).join(' · ')}
                            onClick={run(() => (on.menuDe ? on.menuDe(sv, fila) : on.detalle(sv)))} />;
                    })}
                    {on.cierre && <Opcion Icon={LuFileText} label="Cierre mensual" sub="Calcular el mes y armar el PDF" onClick={run(() => on.cierre(fila))} />}
                </>
            )}
            {s && <Opcion Icon={LuEye} label="Ver detalle" onClick={run(() => on.detalle(s))} />}
            {editable && <Opcion Icon={LuPencil} label="Editar" onClick={run(() => on.editar(s, fila.orden))} />}
            {s && !esArchivado && <Opcion Icon={LuCopy} label="Duplicar" sub="Mismo cliente y equipos, nuevo presupuesto" onClick={run(() => on.duplicar(s))} />}
            {s && <Opcion Icon={LuFileText} label="PDF" onClick={run(() => on.pdf(s))} />}
            {s && <Opcion Icon={LuClipboardList} label="PDF sin precios" onClick={run(() => on.pdf(s, { sinPrecios: true }))} />}
            {editable && (s.enEspera
                ? <Opcion Icon={LuPlay} label="Retomar" sub="Vuelve a Presupuesto para asignar" onClick={run(() => on.espera(s, false))} />
                : <Opcion Icon={LuPause} label="Poner en espera" sub="El cliente todavía no confirmó" onClick={run(() => on.espera(s, true))} />)}
            {s && !esArchivado && <Opcion Icon={LuArchive} label="Archivar" onClick={run(() => on.archivar(s))} />}
            {esArchivado && <Opcion Icon={LuRotateCcw} label="Recuperar" sub="Vuelve como presupuesto" onClick={run(() => on.recuperar(s))} />}
            {fila.orden && !s && <Opcion Icon={LuPencil} label="Editar visita" onClick={run(() => on.editarOrden(fila.orden))} />}
            {/* Visita sin presupuesto (5-oct-2026): antes no había cómo sacarla de la lista */}
            {fila.orden && !s && fila.orden.estado !== 'COMPLETADA' && (
                <Opcion Icon={LuCalendarX} label="Cancelar visita" sub="Sale de la agenda del técnico; queda en el historial" onClick={run(() => on.cancelarOrden(fila.orden))} />
            )}
            {fila.orden && !s && fila.orden.estado !== 'COMPLETADA' && (
                <Opcion Icon={LuTrash2} label="Eliminar visita" sub="Se borra del todo. No se puede deshacer" peligro onClick={run(() => on.eliminarOrden(fila.orden))} />
            )}
            {s && <Opcion Icon={LuTrash2} label="Eliminar" sub="No se puede deshacer" peligro onClick={run(() => on.eliminar(s))} />}
        </ActionSheet>
    );
}
